import { Box, Button, Stack, Switch, Typography } from "@mui/material";
import { defectRiceLevel } from "utility/constants";
import { TYPE_RICE_SETTING } from "../SettingMenu/context";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useState, useMemo } from "react";
import { CardContentSecondary } from "components/card";
import { useDialog } from "context/Dialog";

const CardRoot = styled(Box)<{ selectLevel: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  /* box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2); */
  :hover {
    box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2);
  }
  width: 72px;
  height: 105px;
  ${(props: any) =>
    props.selectLevel === true &&
    `
      border: 3px solid ${props.theme.palette.primary.light01};
    `};
  :hover {
    border: 3px solid rgba(0, 0, 0, 0.04);
    ${(props: any) =>
      props.selectLevel === true &&
      `
      border: 3px solid ${props.theme.palette.primary.light01};
    `};
  }
`;

const CardImage = styled("img")`
  width: 71px;
  height: 85px;
  object-fit: cover;
`;

const CardShowSelect = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  width: 150px;
  height: 200px;
  border: 3px solid rgba(0, 0, 0, 0.04);
`;

const CardSelectLevel = ({ image, selectLevel = false, color }) => {
  return (
    <CardRoot selectLevel={selectLevel}>
      <CardImage src={image} alt={"level"} />
      <Box sx={{ height: "20px", width: "100%", background: color }} />
    </CardRoot>
  );
};

const CardSelectYellowLevel = ({ onChange, value = 2, autoYellow = false, onAutoYellow, isAllowEdit= false }) => {
  const { t } = useTranslation();
  const { getUseFunctionBetaDialog } = useDialog();

  const [hoverValue, setHoverValue] = useState(value);
  const handleChange = (value) => {
    onChange(value);
  };
  const getImageShowExample = useMemo(() => {
    return defectRiceLevel[TYPE_RICE_SETTING.YELLOW].find(({ id }) =>
      hoverValue ? id === hoverValue : id === value
    );
  }, [hoverValue, value]);

  const showSelectLevel = useMemo(() => !autoYellow, [autoYellow]);

  const handleSwitchAutoYellow = (flag: boolean) => {
    if (flag) {
      getUseFunctionBetaDialog({
        onSubmit: () => {
          onAutoYellow(true);
        },
      });
    } else {
      onAutoYellow(false);
    }
  };
  return (
    <>
      <Stack spacing={3}>
        <CardContentSecondary>
          <Typography variant="h6">{t("settingLevel.select_level")}</Typography>
        </CardContentSecondary>
        <Stack direction="row" justifyContent="space-between">
          <Stack>
            <Typography variant="h6">{t("settingLevel.select_yellow_auto")}</Typography>
            <Typography variant="body1" color="text.secondary">
              {t("settingLevel.note_select_yellow_auto")}
            </Typography>
          </Stack>
          <Switch
            color="success"
            checked={autoYellow}
            onChange={(event) => handleSwitchAutoYellow(event.target.checked)}
            disabled={!isAllowEdit}
          />
        </Stack>
        {!showSelectLevel && (
          <Button
            size="small"
            sx={{ textDecoration: "underline" }}
            onClick={() => onAutoYellow(false)}
            disabled={!isAllowEdit}
          >
            {t("settingLevel.cancel_select_yellow_auto")}
          </Button>
        )}
        {showSelectLevel && (
          <>
            <Box sx={{ background: "#FAFAFA", px: 3, py: 1.5 }}>
              <Stack
                sx={{ pb: "12px", overflowX: "auto" }}
                spacing="4px"
                direction="row"
                justifyContent={{ xs: "flex-start", md: "center" }}
              >
                {defectRiceLevel[TYPE_RICE_SETTING.YELLOW].map(({ image, id, level }) => {
                  return (
                    <Stack key={id} justifyContent={"center"} alignItems={"center"} spacing={0.5}>
                      <Box
                        onClick={() => handleChange(id)}
                        onMouseEnter={() => setHoverValue(+id)}
                        onMouseLeave={() => setHoverValue(null)}
                      >
                        <CardSelectLevel
                          image={image.normal}
                          selectLevel={id === value}
                          color={image.color}
                        />
                      </Box>
                      <Box sx={{ textAlign: "center", fontSize: "12px" }}>{level}</Box>
                      <LineSelectLevel state={handleLineState(id, value)} />
                    </Stack>
                  );
                })}
              </Stack>

              <div style={{ textAlign: "center" }}>
                <Typography variant="body3" sx={{ color: "text.secondary" }}>
                  {t("settingLevel.ชี้ที่รูปเพื่อแสดงผลตัวอย่าง")}
                </Typography>
              </div>
            </Box>

            <CardContentSecondary>
              <Typography variant="h6">{t("example")}</Typography>
            </CardContentSecondary>
            {value && (
              <Stack justifyContent={"center"} alignItems="center">
                <CardShowSelect>
                  <img
                    src={getImageShowExample.image.normal}
                    alt={"level"}
                    width={150}
                    height={177}
                    style={{ objectFit: "cover" }}
                  />
                  <Box
                    sx={{
                      height: "20px",
                      width: "100%",
                      background: getImageShowExample.image.color,
                    }}
                  />
                </CardShowSelect>
              </Stack>
            )}
          </>
        )}
      </Stack>
    </>
  );
};

export default CardSelectYellowLevel;

const handleLineState = (id, value) => {
  if (id === value) return "select";
  else if (id > value) return "highlight";
  else return "";
};

const LineSelectLevel = ({ state }) => {
  let color = "";
  if (state === "select") color = "#1F7B44";
  else if (state === "highlight") color = "#A5CB97";
  else color = "#909090";

  return (
    <Box sx={{ background: color, border: `3px solid ${color}`, width: "40px", borderRadius: 1 }} />
  );
};
